__turbopack_context__.v({
  "bordered": "styles-module-scss-module__VovnGa__bordered",
  "closed": "styles-module-scss-module__VovnGa__closed",
  "header": "styles-module-scss-module__VovnGa__header",
  "leftCta": "styles-module-scss-module__VovnGa__leftCta",
  "nav": "styles-module-scss-module__VovnGa__nav",
  "sections": "styles-module-scss-module__VovnGa__sections",
  "shell": "styles-module-scss-module__VovnGa__shell",
  "subtle": "styles-module-scss-module__VovnGa__subtle",
  "title": "styles-module-scss-module__VovnGa__title",
});
